document.addEventListener('DOMContentLoaded', () => {
    // main menu toggle
    for (const el of document.querySelectorAll('.open-menu-main')) {
        el.addEventListener('click', () => {
            document.body.classList.toggle('menu-main-open')
        })
    }
})
